// utils/applyConditionalDisplay.js

/**
 * Apply conditional display rules (x-show-if) dynamically.
 * Never delete fields. Only mark:
 *  - x-hidden
 *  - x-effective-required
 */

export function applyConditionalDisplay(schema, formData) {
  if (!schema) return schema;

  const clone = structuredClone(schema);

  if (!clone.properties) return clone;

  Object.entries(clone.properties).forEach(([tabKey, tab]) => {
    if (typeof tab === "object") {
      processNode(tab, formData, tabKey);
    }
  });

  return clone;
}

// -----------------------------------------------------------------------------
//  Evaluate a single condition operator
// -----------------------------------------------------------------------------

function evaluateCondition(fieldValue, operator, expected) {
  switch (operator) {
    case "=":
    case "==":
      return fieldValue == expected;

    case "!=":
      return fieldValue != expected;

    case ">":
      return Number(fieldValue) > Number(expected);

    case ">=":
      return Number(fieldValue) >= Number(expected);

    case "<":
      return Number(fieldValue) < Number(expected);

    case "<=":
      return Number(fieldValue) <= Number(expected);

    case "in":
      return String(expected).split(",").map(s => s.trim()).includes(fieldValue);

    case "not in":
      return !String(expected).split(",").map(s => s.trim()).includes(fieldValue);

    default:
      return true;
  }
}

// -----------------------------------------------------------------------------
//  Recursively process any node (tab, field, layout, etc.)
// -----------------------------------------------------------------------------

function processNode(node, formData, tabKey) {
  if (!node || typeof node !== "object") return;

  // Standard properties block
  if (node.properties) {
    Object.entries(node.properties).forEach(([childKey, child]) => {
      applyShowIf(child, formData, tabKey);
      processNode(child, formData, tabKey);
    });
  }

  // Layout structure x-structure
  if (Array.isArray(node["x-structure"])) {
    node["x-structure"].flat().forEach((childKey) => {
      const child = node.properties?.[childKey];
      if (child) {
        applyShowIf(child, formData, tabKey);
        processNode(child, formData, tabKey);
      }
    });
  }
}

// -----------------------------------------------------------------------------
//  Apply x-show-if on a field
// -----------------------------------------------------------------------------

function applyShowIf(field, formData) {
  if (!field || typeof field !== "object") return;

  const rules = field["x-show-if"];




  // Pas de condition
  if (!Array.isArray(rules) || rules.length === 0) {

    field["x-hidden"] = false;
    field["x-effective-required"] = field["x-required"] === true;

    return;
  }

  const allTrue = rules.every((rule, idx) => {
    const target = rule.name;
    const operator = rule.operator || "=";
    const expected = rule.value;

    const fieldValue = getValueByPath(formData, target);



    const result = evaluateCondition(fieldValue, operator, expected);


    return result;
  });


  field["x-hidden"] = !allTrue;
  field["x-effective-required"] =
    allTrue && field["x-required"] === true;


}

function getValueByPath(obj, path) {
  if (!obj || !path) return undefined;
  return path.split(".").reduce((acc, key) => {
    if (acc && typeof acc === "object" && key in acc) {
      return acc[key];
    }
    return undefined;
  }, obj);
}